<template>
  <div>
    <v-layout v-if="!hideMain" wrap>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('name') }}</label>
        <input
          v-model.lazy="filter.fullname"
          type="text"
          :placeholder="$t('name')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('Channel') }}</label>
        <multiselect
          v-model="filter.app"
          :options="channelOptions"
          label="label"
          select-label
          selected-label
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('gender') }}</label>
        <multiselect
          v-model="filter.gender"
          :options="genderOptions"
          label="label"
          select-label
          selected-label
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('Locale') }}</label>
        <multiselect
          v-model="filter.locale"
          :options="localeOptions"
          label="title"
          select-label
          selected-label
          deselect-label
          track-by="value"
          :multiple="true"
          :placeholder="$t('Locale')"
        >
          <template slot="option" slot-scope="props">
            <flag :iso="props.option.icon" />

            {{ props.option.title }}
          </template>
        </multiselect>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pa-1">
        <div>
          <label for>{{ $t('First Conversation at') }}</label>
        </div>
        <v-layout>
          <v-flex class="pa-1">
            <datepicker
              v-model="filter.registerDate.start"
              :placeholder="$t('from')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onRegisterStartDate"
            ></datepicker>
          </v-flex>
          <v-flex class="pa-1">
            <datepicker
              v-model="filter.registerDate.end"
              style
              :placeholder="$t('to')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onRegisterEndDate"
            ></datepicker>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pa-1">
        <div>
          <label for>{{ $t('Last Conversation at') }}</label>
        </div>
        <v-layout>
          <v-flex class="pa-1">
            <datepicker
              v-model="filter.activeDate.start"
              :placeholder="$t('from')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onActiveStartDate"
            ></datepicker>
          </v-flex>
          <v-flex class="pa-1">
            <datepicker
              v-model="filter.activeDate.end"
              style
              :placeholder="$t('to')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onActiveEndDate"
            ></datepicker>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('Email') }}</label>
        <input
          v-model.lazy="filter.email"
          type="text"
          :placeholder="$t('Email')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('phone no.') }}</label>
        <input
          v-model.lazy="filter.phoneno"
          type="text"
          placeholder="Phone No"
          class="form-control"
          maxlength="255"
        />
      </v-flex>

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('LINEID') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('filterLineId') }">
          <input
            v-model.lazy="filter.lineid"
            type="text"
            class="form-control"
            name="filterLineId"
            data-vv-name="filterLineId"
            :data-vv-as="$t('LINEID')"
            :placeholder="$t('LINEID')"
          />

          <p v-if="errors.has('filterLineId')" class="text-error">
            {{ errors.first('filterLineId') }}
          </p>
        </div>
      </v-flex>

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('School') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('School') }">
          <multiselect
            v-model="filter.school"
            :options="allSchools"
            :options-limit="10"
            :loading="isLoading"
            placeholder="Select one"
            label="name"
            track-by="name"
            @search-change="asyncFindSchools"
          ></multiselect>
          <p v-if="errors.has('School')" class="text-error">{{ errors.first('School') }}</p>
        </div>
      </v-flex>

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('Province') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Province') }">
          <input
            v-model.lazy="filter.province"
            type="text"
            class="form-control"
            name="Province"
            data-vv-name="Province"
            :data-vv-as="$t('Province')"
            :placeholder="$t('Province')"
          />

          <p v-if="errors.has('Province')" class="text-error">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Context') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            v-model.lazy="filter.context"
            type="text"
            class="form-control"
            name="Context"
            data-vv-name="Context"
            :data-vv-as="$t('Context')"
            :placeholder="$t('Context')"
          />

          <p v-if="errors.has('Context')" class="text-error">{{ errors.first('Context') }}</p>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Customer Types') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <multiselect
            v-model="filter.specialcondition"
            :options="specialconditionOptions"
            :searchable="false"
            label="label"
            track-by="value"
            select-label
            selected-label
            deselect-label
            :placeholder="$t('Conversation')"
          ></multiselect>

          <p v-if="errors.has('Province')" class="text-error">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>

      <v-flex v-if="isJuzmatchCrm" xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('account_types') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <multiselect
            v-model="filter.juzmatch_member_role"
            :options="juzmatchAccountOption"
            :searchable="false"
            label="label"
            track-by="value"
            select-label
            selected-label
            deselect-label
            :placeholder="$t('Conversation')"
          ></multiselect>

          <p v-if="errors.has('Province')" class="text-error">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>

      <v-flex v-if="selectedBot.type === 'summithr'" xs12 sm6 md3 class="form-control pa-1">
        <label>สถานะพนักงาน</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('member_status') }">
          <multiselect
            v-model="filter.member_status"
            :options="
              selectedBot.pageid == '105763258933863' || selectedBot.type === 'summithr'
                ? ['active', 'inactive', 'sign out']
                : ['active', 'inactive']
            "
            :searchable="false"
            select-label
            selected-label
            deselect-label
            placeholder="สถานะพนักงาน"
          ></multiselect>

          <p v-if="errors.has('member_status')" class="text-error">
            {{ errors.first('member_status') }}
          </p>
        </div>
      </v-flex>

      <v-flex v-if="selectedBot.type === 'jamsai'" xs12 sm6 md3 class="form-control pa-1">
        <label>Jamsai ID</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            v-model.lazy="filter.jamsai_id"
            type="text"
            class="form-control"
            name="Jamsai ID"
            data-vv-name="Jamsai ID"
            :data-vv-as="$t('Jamsai ID')"
            :placeholder="$t('Jamsai ID')"
          />

          <p v-if="errors.has('Jamsai ID')" class="text-error">{{ errors.first('Jamsai ID') }}</p>
        </div>
      </v-flex>

      <v-flex
        v-if="$store.state.ntnPage.includes(selectedBot.pageid)"
        xs12
        sm6
        md3
        class="form-control pa-1"
      >
        <label for>{{ $t('Recurring Notification Status') }}</label>
        <multiselect
          v-model="opt_in"
          :options="optInOption"
          label="label"
          select-label
          selected-label
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
          @select="onSelectOptIn"
        ></multiselect>
      </v-flex>
      <v-flex v-if="selectedBot.theme == 'sahapan'" xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Realname') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            v-model="filter.realname"
            type="text"
            class="form-control"
            name="Context"
            data-vv-name="Context"
            :data-vv-as="$t('Real name')"
            :placeholder="$t('Real name')"
          />

          <p v-if="errors.has('Province')" class="text-error">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>

      <v-flex v-if="selectedBot.theme == 'aira'" xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Aira ID') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            v-model="filter.aira_id"
            type="text"
            class="form-control"
            name="aira_id"
            data-vv-name="aira_id"
            :data-vv-as="$t('Aira Id')"
            :placeholder="$t('Aira Id')"
          />

          <p v-if="errors.has('aira_id')" class="text-error">{{ errors.first('aira_id') }}</p>
        </div>
      </v-flex>

      <v-flex xs6 class="form-control pa-1" :class="{ 'has-error': errorFilterTag.length > 0 }">
        <label for>{{ $t('Tag') }}</label>
        <template v-if="showTagType || $store.state.toaNewDealerPage.includes(selectedBot.pageid)">
          <v-radio-group v-model="filter.tagtype" color="primary" row class="text-xs-center">
            <v-radio color="primary" :label="$t('Includes')" :value="'includes'"></v-radio>
            <v-radio color="primary" :label="$t('Excludes')" :value="'excludes'"></v-radio>
          </v-radio-group>
          <tags
            v-model="tag"
            :tags="tags"
            style="margin-bottom: 5px"
            :btn-text="$t('Add tag')"
            :item-option="tagOptions"
            :combobox="true"
            @tags-changed="addTags"
            @before-adding-tag="checkTag"
          ></tags>
        </template>
        <template v-else>
          <tags
            v-model="tag"
            :tags="tags"
            style="margin-bottom: 10px"
            :btn-text="$t('Add tag')"
            :is-drag="false"
            @tags-changed="addTags"
            @before-adding-tag="checkTag"
          ></tags>
        </template>

        <span v-if="errorFilterTag.length > 0" class="text-error">
          <template v-if="errorFilterTag.includes('overmaxlength')">{{
            $t('Message cannot be longer than 20 alphabets')
          }}</template>
          <template v-else-if="errorFilterTag.includes('duplicate')">{{
            $t('Duplicate Tag')
          }}</template>
        </span>
      </v-flex>
      <v-flex xs12 class="form-control pa-1">
        <label for>{{ $t('Status') }}</label>
        <v-radio-group v-model="filter.statustype" color="primary" row class="text-xs-center">
          <v-radio color="primary" :label="$t('Includes')" :value="'includes'"></v-radio>
          <v-radio color="primary" :label="$t('Excludes')" :value="'excludes'"></v-radio>
        </v-radio-group>
        <multiselect
          v-model="filter.status"
          :options="userStatus"
          :searchable="true"
          select-label
          selected-label
          deselect-label
          :multiple="true"
          :placeholder="$t('Status')"
          @select="$emit('onChangeStatus')"
          @remove="$emit('onChangeStatus')"
        ></multiselect>
      </v-flex>
      <v-flex v-if="isGpfBuddy" xs12>
        <div class="mt-4">
          <div class="hr"></div>
          <div class="py-4 px-2">
            <v-layout row wrap>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('company') }}</div>
                  <div>
                    <multiselect
                      v-model="filter.gpf_company_code"
                      :options="gpfBuddyOption.companies"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="company_code"
                      label="company_name"
                      @input="onChangeGpfBuddyOptions('company')"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('work_group') }}</div>
                  <div>
                    <multiselect
                      v-model="filter.gpf_group_code"
                      :disabled="
                        filter.gpf_company_code && filter.gpf_company_code.company_code === 'All'
                      "
                      :options="gpfBuddyOption.groups"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="group_code"
                      label="group_name"
                      @input="onChangeGpfBuddyOptions('group')"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('department') }}</div>
                  <div>
                    <multiselect
                      v-model="filter.gpf_department_code"
                      :disabled="
                        filter.gpf_group_code && filter.gpf_group_code.group_code === 'All'
                      "
                      :options="gpfBuddyOption.departments"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="department_code"
                      label="department_name"
                      @input="onChangeGpfBuddyOptions('department')"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
              <v-flex xs3 class="px-1">
                <div class="form-control">
                  <div class="primary--text caption">{{ $t('position') }}</div>
                  <div>
                    <multiselect
                      v-model="filter.gpf_position_code"
                      :disabled="
                        filter.gpf_department_code &&
                        filter.gpf_department_code.department_code === 'All'
                      "
                      :options="gpfBuddyOption.positions"
                      :allow-empty="false"
                      :searchable="true"
                      :open-direction="'bottom'"
                      select-label
                      selected-label
                      deselect-label
                      track-by="position_code"
                      label="position_name"
                    ></multiselect>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-flex>
      <v-flex v-if="['toacrm'].includes(selectedBot.theme)" xs12 class="form-control pa-1">
        <label for>{{ $t('Tier') }}</label>
        <multiselect
          v-model="filter.toa_member_tier"
          :options="toaTierOptions"
          :searchable="false"
          select-label
          selected-label
          deselect-label
          :multiple="false"
          :allow-empty="true"
          placeholder="Tier"
          style="max-width: 300px"
        ></multiselect>
      </v-flex>
    </v-layout>
    <slot name="append" :filter="filter"></slot>
    <div class="text-xs-right pa-1">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import Tags from '@/components/elements/Tags'
import { PAGE } from '@/constants/page.js'

import LivechatSocialChannel from '@/components/view/livechat/LivechatSocialChannelMixin'

export default {
  components: {
    Multiselect,
    datepicker,
    Tags
  },
  mixins: [LivechatSocialChannel],
  props: {
    value: {
      default: undefined
    },
    hideMain: {
      default: false
    },
    showTagType: {
      default: false
    }
  },
  data: function () {
    return {
      payStatus: null,
      opt_in: null,
      allSchools: [],
      isLoading: false,
      filter: this.value,
      channelOptions: [],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('Male'),
          value: 'male'
        },
        {
          label: this.$t('Female'),
          value: 'female'
        },
        {
          label: this.$t('no gender'),
          value: 'other'
        }
      ],
      specialconditionOptions: [
        {
          label: this.$t('Active Users'),
          value: 'activeusers'
        },
        {
          label: this.$t('Potential Users'),
          value: 'potentialusers'
        },
        {
          label: this.$t('Purchased Users'),
          value: 'perchasedusers'
        },
        {
          label: this.$t('Loyal Customer'),
          value: 'perchasedusers_royalty'
        },
        {
          label: this.$t('New Customer'),
          value: 'perchasedusers_newcomer'
        }
      ],
      localeOptions: config.locale,
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than')
        },
        {
          value: 'l__',
          label: this.$t('Less than')
        },
        {
          value: 'n__',
          label: this.$t('Not')
        }
      ],
      intents: [],
      errorFilterTag: [],
      tag: '',
      sendNotiMember: false,
      daySendNoti: '',
      tagOptions: [],
      payOptions: [
        {
          label: this.$t('All'),
          value: ''
        },
        {
          label: this.$t('Paid'),
          value: 'S'
        },
        {
          label: this.$t('Pending'),
          value: 'P'
        }
      ],
      optInOption: [
        {
          label: this.$t('get_message'),
          value: 'daily'
        },
        {
          label: this.$t('get_message_expired'),
          value: 'daily_exp'
        }
      ],
      gpfBuddyOption: {
        positions: [],
        companies: [],
        departments: [],
        groups: []
      },
      juzmatchAccountOption: [
        {
          label: this.$t('invester'),
          value: 'invester'
        },
        {
          label: this.$t('buyer'),
          value: 'buyer'
        }
      ],
      toaTierOptions: ['New Member', 'Regular Member', 'Loyalty Member', 'Inactive Member'],
      channelOptionsLine: [
        {
          label: this.$t('Friends'),
          value: 'line'
        },
        {
          label: this.$t('Group'),
          value: 'line-group'
        }
      ]
    }
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus'
    }),
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    },
    gpfBuddyMasterData() {
      return this.$store.state.gpfBuddyMasterData
    },
    isLamy() {
      return [...this.$store.state.lamyPage].includes(this.selectedBot.pageid)
    },
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    isJuzmatchCrm() {
      return PAGE.JUZMATCH_CRM.includes(this.selectedBot.pageid)
    },
    isTcp() {
      return PAGE.TCP.includes(this.selectedBot.pageid)
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            result = tags.map(function (tag) {
              return { text: tag }
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          result = value.map(function (tag) {
            return tag.text
          })
        }
        vm.filter.tags = result.join(',')
      }
    }
  },
  watch: {
    value: function (newVal) {
      this.filter = newVal
    }
  },
  mounted: function () {
    this.getUserTagList()
    if (this.selectedBot) {
      let customOptions = []
      if (['gpf', 'trueid'].includes(this.selectedBot.type)) {
        customOptions.push({
          label: 'Web Chat',
          value: 'webchat'
        })
      }
      if (['gpf'].includes(this.selectedBot.type)) {
        customOptions.push({
          label: 'App Chat',
          value: 'app'
        })
      }
      this.channelOptions = [
        {
          label: this.$t('All'),
          fullValue: 'all',
          value: 'all'
        },
        ...this.socialChannelOptions.map((social) => {
          return {
            value: social.fullValueForUse,
            label: this.$t(social.text)
          }
        }),
        ...customOptions
      ]

      if (this.isGpfBuddy) {
        this.handleInitialGpfBuddy()
      }
    }
  },
  methods: {
    onSelectOptIn(param) {
      this.filter.opt_in = param.value
    },
    onSelectPayStatus(param) {
      this.filter.payStatus = param.value
    },
    async FindSchools(data) {
      let vm = this
      if (!vm.allSchools.length && !vm.isLoading) {
        vm.isLoading = true
        api.getschoollist(data, function (error, response) {
          if (error) {
            console.error(error)
          } else {
            vm.allSchools = response.data
            vm.isLoading = false
          }
        })
      }
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 9999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    onActiveStartDate: function (value) {
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
      this.$emit('onUpdate')
    },
    onActiveEndDate: function (value) {
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
      this.$emit('onUpdate')
    },
    onRegisterStartDate: function (value) {
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
      this.$emit('onUpdate')
    },
    onRegisterEndDate: function (value) {
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
      this.$emit('onUpdate')
    },
    async getUserTagList() {
      var response = await api.getUserTagList()
      if (response && response.result) {
        this.tagOptions = response.result.map((item) => {
          return item.name
        })
      }
    },
    handleInitialGpfBuddy() {
      const vm = this
      const gpfBuddyMasterData = vm.gpfBuddyMasterData

      let tempCompanyOptions = []
      tempCompanyOptions.push({ company_code: 'All', company_name: 'All', groups: [] })
      tempCompanyOptions.push(...gpfBuddyMasterData)
      vm.gpfBuddyOption.companies = tempCompanyOptions

      let tempGroupOptions = []
      tempGroupOptions.push({ group_code: 'All', group_name: 'All', departments: [] })
      vm.gpfBuddyOption.groups = tempGroupOptions

      let tempDepartmentOptions = []
      tempDepartmentOptions.push({ department_code: 'All', department_name: 'All', positions: [] })
      vm.gpfBuddyOption.departments = tempDepartmentOptions

      let tempPositionOptions = []
      tempPositionOptions.push({ position_code: 'All', position_name: 'All' })
      vm.gpfBuddyOption.positions = tempPositionOptions

      let selectedCompany = null
      if (vm.filter.gpf_company_code && vm.filter.gpf_company_code.company_code !== 'All') {
        selectedCompany = gpfBuddyMasterData.find((el) => {
          return el.company_code === vm.filter.gpf_company_code
        })
        vm.$set(vm.filter, 'gpf_company_code', selectedCompany)
      } else {
        vm.$set(vm.filter, 'gpf_company_code', {
          company_code: 'All',
          company_name: 'All',
          groups: []
        })
      }

      let selectedGroup = null
      if (
        selectedCompany &&
        vm.filter.gpf_group_code &&
        vm.filter.gpf_group_code.group_code !== 'All'
      ) {
        selectedGroup = selectedCompany.groups.find((el) => {
          return el.group_code === vm.filter.gpf_group_code
        })

        vm.$set(vm.filter, 'gpf_group_code', selectedGroup)
      } else {
        vm.$set(vm.filter, 'gpf_group_code', {
          group_code: 'All',
          group_name: 'All',
          departments: []
        })
      }

      let selectedDepartment = null
      if (
        selectedGroup &&
        vm.filter.gpf_department_code &&
        vm.filter.gpf_department_code.department_code !== 'All'
      ) {
        selectedDepartment = selectedGroup.departments.find(
          (el) => el.department_code == vm.filter.gpf_department_code
        )
        vm.$set(vm.filter, 'gpf_department_code', selectedDepartment)
      } else {
        vm.$set(vm.filter, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
      }

      if (vm.filter.gpf_position_code && vm.filter.gpf_position_code.position_code !== 'All') {
        let selectedPosition = selectedDepartment.positions.find(
          (el) => el.position_code == vm.filter.gpf_position_code
        )
        vm.$set(vm.filter, 'gpf_position_code', selectedPosition)
      } else {
        vm.$set(vm.filter, 'gpf_position_code', { position_code: 'All', position_name: 'All' })
      }
    },
    handleSetGpfBuddyOptions() {
      const vm = this
      const selectedCompany = vm.filter.gpf_company_code
      const selectedGroup = vm.filter.gpf_group_code
      const selectedDepartment = vm.filter.gpf_department_code

      if (selectedCompany && selectedCompany.company_code !== 'All') {
        let tempGroupOptions = []
        tempGroupOptions.push({ group_code: 'All', group_name: 'All', departments: [] })
        tempGroupOptions.push(...selectedCompany.groups)
        vm.gpfBuddyOption.groups = tempGroupOptions
      }

      if (selectedGroup && selectedGroup.group_code !== 'All') {
        let tempDepartmentOptions = []
        tempDepartmentOptions.push({
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
        tempDepartmentOptions.push(...selectedGroup.departments)
        vm.gpfBuddyOption.departments = tempDepartmentOptions
      }

      if (selectedDepartment && selectedDepartment.department_code !== 'All') {
        let tempPositionOptions = []
        tempPositionOptions.push({ position_code: 'All', position_name: 'All' })
        tempPositionOptions.push(...selectedDepartment.positions)
        vm.gpfBuddyOption.positions = tempPositionOptions
      }
    },
    onChangeGpfBuddyOptions(type) {
      const vm = this
      if (type === 'company') {
        vm.$set(vm.filter, 'gpf_group_code', {
          group_code: 'All',
          group_name: 'All',
          departments: []
        })
        vm.$set(vm.filter, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
        vm.$set(vm.filter, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'All'
        })
      } else if (type === 'group') {
        vm.$set(vm.filter, 'gpf_department_code', {
          department_code: 'All',
          department_name: 'All',
          positions: []
        })
        vm.$set(vm.filter, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'All'
        })
      } else if (type === 'department') {
        vm.$set(vm.filter, 'gpf_position_code', {
          position_code: 'All',
          position_name: 'All'
        })
      }

      vm.handleSetGpfBuddyOptions()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/FilterCustomer.vue